import React from 'react';
import { useIntl } from 'react-intl';

import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import { Compass } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { BluViuNutritionParams } from '../types/bluviu-nutrition-params.type';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const BluViuNutritionTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const { account } = useAccountState();
  const params = useParams<BluViuNutritionParams>();
  const userId = account.currentUser?.id ?? '';

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: account.company?.features?.hasScenarioBuilder,
          label: intl.formatMessage({ id: 'bluViuNutrition.navigation.listBluViuNutritionR2' }),
          to: `/bluviu-nutrition/r2${!params?.globalSiteId ? '' : `/${params.globalSiteId}`}`,
        },
        {
          hasAccess: account.company?.features?.hasScenarioBuilder,
          label: intl.formatMessage({ id: 'bluViuNutrition.navigation.listScenarios' }),
          to: `/bluviu-nutrition/scenarios${!params?.globalSiteId ? '' : `/${params.globalSiteId}`}`,
        },
        {
          hasAccess: account.company?.features?.hasScenarioBuilder,
          label: intl.formatMessage({ id: 'bluViuNutrition.navigation.listCalibrations' }),
          to: `/bluviu-nutrition/calibrations${!params?.globalSiteId ? '' : `/${params.globalSiteId}`}`,
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Compass size={25} color={'white'} />}
    />
  );
};

export default React.memo(BluViuNutritionTabsHeader);
